export default __webpack_public_path__ + "static/Nox7-e109dad3d2a7eed7bf8093ca47f42942.png";